<template>
  <div>
    <van-popup v-model="show" @close="close" :close-on-click-overlay="false">
      <div class="container" v-if="options">
        <div class="title">
          <slot name="title">{{ options.title }}</slot>
        </div>
        <div class="content">
          <slot name="content">{{ options.message }}</slot>
        </div>
        <div class="btn-box">
          <button class="btn cancel" v-if="options.cancelShow" @click="onCancel">{{ options.cancelText }}</button>
          <button class="btn confirm" @click="onConfirm">{{ options.confirmText }}</button>
        </div>
        <div class="tips" v-if="$slots.tips">
          <slot name="tips"></slot>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'

export default {
  name: 'PopupMessage',
  components: {
    VanPopup: Popup
  },
  data () {
    return {
      show: false,
      options: null
    }
  },
  methods: {
    init () {
      this.options = {
        title: '',
        message: '',
        confirmText: '确定',
        cancelText: '取消',
        cancelShow: true,
        cancelFn: null,
        confirmFn: null
      }
    },
    open (options) {
      this.init()
      this.show = true
      this.options = {
        ...this.options,
        ...options
      }
    },
    close () {
      this.show = false
    },
    onCancel () {
      if (this.options.cancelFn) {
        this.options.cancelFn(this.close)
      } else {
        this.close()
      }
    },
    onConfirm () {
      if (this.options.confirmFn) {
        this.options.confirmFn(this.close)
      } else {
        this.close()
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.van-popup {
  background: transparent;
}
.container {
  width: 5.98rem;
  background: #ffffff;
  padding: 0.26rem 0.40rem 0.50rem;
  border-radius: 0.14rem;

  .title {
    font-size: 0.32rem;
    font-weight: bold;
    color: #FF3636;
    text-align: center;
  }
  .content {
    min-height: 2.00rem;
    padding: 0.20rem 0;
    font-size: 0.24rem;
    color: #545454;
    .flex-center;
  }
  .btn-box {
    .flex-center;

    .btn {
      width: 2.40rem;
      height: 0.62rem;
      border-radius: 999rem;
      font-size: 0.24rem;
      color: #444444;
      border: 0.01rem solid #DCDCDC;

      & + .btn {
        margin-left: 0.36rem;
      }
      &.confirm {
        background: #F96D09;
        border: none;
        color: #FFFFFF;
      }
    }
  }
  .tips {
    margin-top: 0.26rem;
    font-size: 0.22rem;
    color: #939393;
    text-align: center;
  }
}
</style>
